// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1fk6S","right":"Footer_right__3cpu1","buttons":"Footer_buttons__3QjCt"};